import { ILoadableWrapper } from "../../../models";
import { ISensor } from "../../../models/sensor.interface";
import { LoadableSensors, SitesState } from "../site.state";

export const updateSensorsInSiteState = (
    state: SitesState,
    sensors: ISensor[],
    updateFn: (existingSensor: ILoadableWrapper<ISensor>) => ILoadableWrapper<ISensor>
) => {
    const newSensorsState: Record<string, LoadableSensors> = { ...state.sensors };

    const sensorsBySite: Record<string, ISensor[]> = sensors.reduce((acc, sensor) => {
        (acc[sensor.site_id] = acc[sensor.site_id] || []).push(sensor);
        return acc;
    }, {} as Record<string, ISensor[]>);

    for (const siteID in sensorsBySite) {
        if (!newSensorsState[siteID]) {
            continue;
        }

        const updatedSensorIDs = new Set(sensorsBySite[siteID].map(sensor => sensor.id));

        const newItems: ILoadableWrapper<ISensor>[] = newSensorsState[siteID].items.map(existingSensor => {
            if (updatedSensorIDs.has(existingSensor.id)) {
                return updateFn(existingSensor);
            }
            return existingSensor;
        });

        newSensorsState[siteID] = {
            ...newSensorsState[siteID],
            items: newItems
        };
    }

    return {
        ...state,
        sensors: newSensorsState,
    };
};
